export default "__VITE_PUBLIC_ASSET__1492a49e__"